import React from 'react';
import { Provider } from 'react-redux';
import { loadContainers } from '@eika-infrastruktur/render';

import configureStore from './configure-store';

import App from './App';
import Avtale from './containers/Avtale/Avtale';
import BankIdInfo from './containers/BankIdInfo/BankIdInfo';
import { AppContextProvider } from './context/AppContextProvider';

import { DefaultConfig } from './default-config';

import './styles/app.scss';

const store = configureStore();

const renderApp = (MyApp: React.ComponentType, namespace: string, param?: any) => {
    loadContainers( namespace, (props) => {
        return <Provider store={store}>
            <div className="infrastruktur-bankid-customer sgw-layout large-centered-container">
                <AppContextProvider>
                    <MyApp {...props} {...(param || {})} />
                </AppContextProvider>
            </div>
        </Provider>
    }, DefaultConfig);
};

// @ts-ignore
// sjekk namespace
renderApp(App, 'infrastruktur-bankid-customer');
// @ts-ignore
renderApp(Avtale, 'infrastruktur-bankid-customer.avtale');
renderApp(BankIdInfo, 'infrastruktur-bankid-customer.bankid-info');
